module.exports = __webpack_public_path__ + "static/media/004-oman.1938ff08.svg";